/* eslint-disable require-jsdoc */

import dmaDistanceCalculation from "./distance";

const dmas = [
    {
    name: 'boston',
    tag: 'dma_boston',
        bounds: {
        north: 43.230716,
        south: 41.3341534,
        west: -73.27,
        east: -69.8000000
        },
    center: {lat: 42.3601, lon: -71.0589},
    },
    {
      name: 'lexington',
      tag: 'dma_lexington',
        bounds: {
          north: 38.22067,
          south: 37.88374,
          west: -84.66820,
          east: -84.27462,
        },
        center: {lat: 38.0406, lon: -84.5037},

    }

]

function getNearestDma(lat, lon) {
    let nearestDma = dmas[0];
    let nearestDist = 9999999;
    dmas.forEach((dma) => {
        const currDist = dmaDistanceCalculation( lat, lon, dma.center);
   //     console.log('curr dist ', currDist);
        if ( currDist < nearestDist) {
            nearestDist = currDist;
            nearestDma = dma; 
        }
    })
   return nearestDma;
}
export{ getNearestDma }